import React from "react";
import { AppUser } from "../models/appUser";

export const UserContext = React.createContext({
  appUser: {} as AppUser,
  setAppUser: (u:AppUser) => {}
});
